'use client';

import styles from './MeasurementPlan.module.scss';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  isEn: boolean;
}

export function LoadingState({ isEn }: LoadingStateProps) {
  return (
    <div className={styles.loadingBox} role="status" aria-live="polite">
      <Loader2 size={32} className={styles.loadingSpinner} aria-hidden="true" />
      <span className={styles.loadingText}>
        {isEn ? 'Building your measurement plan...' : 'Construction de votre plan de mesure...'}
      </span>
      <span className={styles.loadingSubtext}>
        {isEn
          ? 'A single structured analysis, no long generic prose.'
          : 'Une analyse structurée unique, pas de prose générique longue.'}
      </span>
    </div>
  );
}
